import { MEDIAS } from '@/common/js/constants.js'
import { isArray, isEmpty, deepCopy } from '@/common/js/utils'
// import Uploader from '../media/uploader'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { AssetsSelector, makeSelectorForm } from '@/components/material-selector/index.js'

export default {
  // components: { Uploader },
  components: { AssetsSelector },
  data() {
    return {
      MATERIAL_TYPE_ID,
      MATERIAL_TYPE,
      MATERIAL_TYPE_SIZES: {
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]]: [{ label: '1280*720' }, { label: '720*1280' }, { label: '1920*1080' }, { label: '1080*1920' }],
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]]: [{ label: '1140*640' }, { label: '370*245' }, { label: '1920*1080' }, { label: '1080*1920' }],
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]]: []
      },
      showSelectorModal: false,
      selectorProps: {
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO],
        form: this.getInitSelectorForm()
      },

      uploadModel: false,
      uploadType: '', // 上传类型
      uploadName: '',
      uploadSmart: 0, // 智能封面视频ID
      uploadWidth: 0,
      uploadHeight: 0,
      uploadSize: 0,
      uploadMult: 1,
      uploadBatch: null,
      isReplaceMode: false
    }
  },
  computed: {
    seletedMaterialRadioDiasbled() {
      // 是否素材替换
      // const isReplaceMode = this.uploadIndex > -1

      const states = {
        [MATERIAL_TYPE.IMAGE]: true,
        [MATERIAL_TYPE.VIDEO]: true,
        cover: true
      }
      // 只能选择对应的素材类型
      states[this.uploadType] = false

      // 替换时，只能选择对应的素材类型
      if (this.isReplaceMode) {
        // 如果替换类型为封面，可以将图片radio放开，让用户可以选择图片作为封面
        if (this.uploadType === 'cover') {
          states[MATERIAL_TYPE.IMAGE] = false
        }
      }

      return states
    }
  },

  methods: {
    switchToType(val) {
      if (val === 'ELEMENT_TYPE_IMAGE') return 'image'
      else if (val === 'ELEMENT_TYPE_VIDEO') return 'video'
      else if (val === 'ELEMENT_TYPE_COVER') return 'cover'
      else throw new Error('未知的素材类型')
    },
    multipleSelect() {
      const multi = this.max - this.len
      let width = 1280
      let height = 720
      if (this.creativeType === 1) {
        // 竖版视频
        width = 720
        height = 1280
      }
      this.uploadBatch = true
      this.uploadType = 'video'
      this.uploadWidth = width
      this.uploadHeight = height
      // this.uploadModel = true
      this.uploadName = 'video'
      this.uploadSize = 102400
      this.uploadMult = parseInt(multi / 15) > 0 ? 15 : multi
      this.isReplaceMode = false

      this.selectorProps.form = this.getInitSelectorForm()
      this.selectorProps.form.sizes = [`${width}*${height}`]
      this.selectorProps.assetType = MATERIAL_TYPE_ID[this.uploadType]
      this.selectorProps.max = this.uploadMult
      this.showSelectorModal = true
    },
    setTemplate(tem) {
      this.template = tem
    },
    selectVidoeMedia() {
      const template = arguments[0]
      const { type, len } = arguments[1]
      let width = 1280
      let height = 720
      if (type === 'vertical') {
        width = 720
        height = 1280
      }
      this.uploadBatch = true
      this.uploadType = 'video'
      this.uploadWidth = width
      this.uploadHeight = height
      this.showSelectorModal = true
      this.uploadName = ''
      this.uploadSmart = 0
      this.uploadSize = 102400
      this.uploadMult = len
      this.template = template
      this.smartCreativeType = type
    },
    selectImageMedia() {
      // 程序化多选图片
      const template = arguments[0]
      const len = arguments[1]
      if (!this.smartVideo) {
        this.$Message.error('请先选择视频素材')
        return
      }
      this.uploadBatch = true
      this.uploadType = 'cover'
      this.uploadWidth = 1280
      this.uploadHeight = 720
      this.showSelectorModal = true
      this.uploadName = 'video'
      this.uploadSize = 2048
      this.uploadMult = len
      this.template = template
      this.smartCreativeType = 0
      this.uploadSmart = this.smartVideo
    },
    switchType(type) {
      this.uploadType = type
    },
    // 选择素材回调
    uploadFileHandle(data) {
      if (!isArray(data)) return
      if (this.uploadType === 'video') {
        if (this.uploadBatch) {
          // 批量添加视频
          if (this.creativeType) this.$emit('on-splice', { type: 'add', mode: this.creativeType, data })
          else if (this.template && this.smartCreativeType) {
            data.forEach((ret) => {
              const template = deepCopy(this.template[this.smartCreativeType])
              const sourceVideo = {
                photo_id: ret.id,
                url: ret.url,
                width: ret.width,
                height: ret.height,
                file_size: ret.size,
                type: this.uploadType
              }

              const sourceCover = {
                image_token: ret.cover_id,
                url: ret.cover_url,
                width: ret.cover_width,
                height: ret.cover_height,
                file_size: ret.cover_size,
                type: 'cover'
              }
              template[template.name] = ret.id
              template.cover = ret.cover_id

              this.smartVideo = ret.id // 让最后一个选中
              this.source.push(sourceVideo)
              this.source.push(sourceCover)

              // 触发 src\views\create\kuaishou_local\idea_mixin.js pushCreative
              this.$emit('on-add', { item: template, index: 0 })
            })
          }
        } else if (this.template) {
          // 程序化替换
          const item = data.pop()
          const template = deepCopy(this.template[this.smartCreativeType])
          const sourceVideo = {
            photo_id: item.id,
            url: item.url,
            width: item.width,
            height: item.height,
            file_size: item.size,
            type: this.uploadType
          }

          const sourceCover = {
            image_token: item.cover_id,
            url: item.cover_url,
            width: item.cover_width,
            height: item.cover_height,
            file_size: item.cover_size,
            type: 'cover'
          }

          template[template.name] = item.id
          template.cover = item.cover_id
          this.smartVideo = item.id
          this.source.push(sourceVideo)
          this.source.push(sourceCover)
          this.$emit('on-replace', { item: template, idx: this.uploadIndex, index: 0 })
        } else {
          // 自定义替换
          const item = data.pop()
          const videoIndex = this.tempalteJson.findIndex((ret) => ret.element === 'ELEMENT_TYPE_VIDEO')
          const coverIndex = this.tempalteJson.findIndex((ret) => ret.element === 'ELEMENT_TYPE_COVER')
          const sourceVideo = {
            photo_id: item.id,
            url: item.url,
            width: item.width,
            height: item.height,
            file_size: item.size,
            type: this.uploadType
          }
          const sourceImage = {
            image_token: item.id,
            url: item.cover_url,
            cover_width: item.cover_width,
            cover_height: item.cover_height,
            cover_size: item.cover_size,
            type: 'video'
          }
          this.$set(this.tempalteJson[videoIndex], this.uploadType, item.id)
          this.$set(this.tempalteJson[coverIndex], 'cover', item.id)
          this.source.push(...[sourceVideo, sourceImage])
        }
      } else if (['cover', 'image'].includes(this.uploadType)) {
        if (this.uploadBatch && this.template) {
          // 批量添加封面
          data.forEach((ret) => {
            const template = deepCopy(this.template)
            const sourceImage = {
              image_token: ret.id,
              url: ret.url,
              width: ret.width,
              height: ret.height,
              file_size: ret.size,
              type: this.uploadType
            }
            template[template.name] = ret.id
            Object.assign(template.restriction, { width: ret.width, height: ret.height })
            this.source.push(sourceImage)

            // 触发 src\views\create\kuaishou_local\idea_mixin.js pushCreative
            this.$emit('on-add', { item: template, index: 1 })
          })
        } else if (this.template) {
          // 程序化替换
          const item = data.pop()
          // const template = deepCopy(this.template)
          const template = {
            name: 'cover',
            cover: '',
            element: 'ELEMENT_TYPE_COVER',
            field: 'FIELD_TYPE_STRING',
            required: true,
            description: '封面dd',
            restriction: {
              width: '1280(720)',
              height: '720(1280)',
              file_size: 2048,
              file_format: ['IMAGE_JPG']
            }
          }

          const sourceImage = {
            image_token: item.id,
            url: item.url,
            width: item.width,
            height: item.height,
            file_size: item.size,
            type: this.uploadType
          }
          template[template.name] = item.id
          Object.assign(template.restriction, { width: item.width, height: item.height })

          const photoItem = this.tempalteJson.find((t) => t.name === 'photo_ids').children.find((c) => c.cover === this.replaceImageId)
          photoItem.cover = sourceImage.image_token

          const srcIndex = this.source.findIndex((s) => s.image_token === this.replaceImageId)

          this.source.splice(srcIndex, 1, sourceImage)

          // this.source.push(sourceImage)
          this.$emit('on-replace', { item: template, idx: this.uploadIndex, index: 1 })
        } else {
          // 自定义替换
          const item = data.pop()
          const coverIndex = this.tempalteJson.findIndex((ret) => ret.element === 'ELEMENT_TYPE_COVER')
          const sourceImage = {
            image_token: item.id,
            url: item.url,
            width: item.width,
            height: item.height,
            file_size: item.size,
            type: this.uploadType
          }
          this.$set(this.tempalteJson[coverIndex], 'cover', item.id)
          this.source.push(sourceImage)
        }
      }
      this.uploadModel = false
      this.showSelectorModal = false
    },
    getInitSelectorForm() {
      return { ...makeSelectorForm(), sizes: ['1280*720'], media_id: MEDIAS.KUAISHOU }
    },
    // 上传完回显
    uploadFileComplet({ file, element }) {
      const index = this.tempalteJson.findIndex((ret) => ret.element === element)
      if (element === 'ELEMENT_TYPE_VIDEO' && index > -1 && file.photo_id) {
        this.tempalteJson[index].video = file.photo_id
        this.source.push(file)
      } else if (element === 'ELEMENT_TYPE_COVER' && index > -1 && file.image_token) {
        this.tempalteJson[index].cover = file.image_token
        this.source.push(file)
      } else if (index > -1 && file.image_token) {
        this.tempalteJson[index].image = file.image_token
        this.source.push(file)
      }
    },
    // 选择文案回调
    appendDocument(data) {
      const docs = deepCopy(data)
      const index = this.tempalteJson.findIndex((ret) => ret.name === this.uploadName)
      if (this.docType === 'smart' && index > -1) {
        // 批量添加
        const child = deepCopy(this.tempalteJson[index].children).pop()
        const appenDocs = docs
          .filter((ret, id) => id < this.docMax)
          .map((ret) => {
            const title = !isEmpty(ret.docContent) && ret.docContent.replace(/{[\u4e00-\u9fa5]{2,}}/g, '') // 去掉头条动态词
            return Object.assign({}, child, { title })
          })
        this.tempalteJson[index].children.push(...appenDocs)
      } else if (index > -1) {
        // const { docContent } = isArray(docs) && docs.pop()
      }
      this.docModel = false
    }
  }
}
